<div id="main-content" *ngIf="directorshipData ; else loading" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent()">
  <form [formGroup]="directorshipForm">

    <h2 class="bofa--heading is-4 double-bottom-space">Directorships</h2>

    <div class="bottom-space">
      <div class="bottom-space">
        <div class="label-space" id="director-radio-group-label"><abbr title="required">* </abbr>Are you currently
          serving
          as a director, advisory board member or officer of any of the following: for-profit entity; non-profit entity;
          non-profit financial organization; financial self-regulatory organization; or a governmental or public purpose
          entity (including elected positions)?
          * “Director” means any service involving the ability to control an organization's governance and/or a duty
          (fiduciary or otherwise) to the organization itself and its investors, such as a director, managing member,
          operating board member, manager, advisory board member, investment committee member, or like service.
        </div>

        <mat-radio-group (focusout)="radioOnBlur()" (focusin)="radioOnFocus()" name="director"
          (change)="onDirectorshipChange()" aria-describedby="director-radio-group-label" formControlName="director"
          aria-required="true" required>
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1" name="director">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="director">No</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="hasBeenSubmittted && director.hasError('required') || checkRadio" class="padding-top">Please
          select above question</mat-error>

      </div>

      <div>
        <div class="label-space" id="compensated-radio-group-label"><abbr title="required">* </abbr>Additionally, are
          you
          employed, compensated or have the reasonable expectation of compensation by any person or organization other
          than Bank of America or its affiliates (i.e. part-time employment, family business, etc.)
        </div>

        <mat-radio-group (focusout)="radioOnBlur()" (focusin)="radioOnFocus()" name="compensated"
          (change)="onDirectorshipChange()" aria-labelledby="compensated-radio-group-label"
          formControlName="compensated" aria-required="true" required>
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1" name="compensated">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="compensated">No</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="hasBeenSubmittted && compensated.hasError('required') || checkRadio"
          class="padding-top">Please select above question</mat-error>
      </div>

    </div>

    <div
      *ngIf="directorshipForm.controls.director.value === '1' || directorshipForm.controls.compensated.value === '1'">
      <div class="double-bottom-space">
        <div>
          <div>
            <div *ngIf="afDirectorshipsList.length === 0" class="padding-top padding-left"> <button
                [disabled]="afDirectorshipsList.invalid" type="button" #addButtonElement class="bofa--button secondary"
                (click)="createDirector('')">Add director</button>
            </div>
          </div>
        </div>

        <!-- set focus when pressing Remove button -->
        <div *ngIf="!afDirectorshipsList.invalid" tabindex="-1" #addElement class="bofa--skiplink">
        </div>

        <div class="director-list">
          <ng-container *ngFor="let directorForm of afDirectorshipsList.controls; let i = index"
            [formGroup]="directorForm" class="double-bottom-space">
            <mat-card appearance="outlined" class="af-mat-card mat-elevation-z flex-change double-bottom-space mat-card-padding director-card"
              [class.border]="blueBorder" [class.border-red]="redBorder">

              <!-- set focus when pressing Add button -->
              <div *ngIf="directorForm.invalid" tabindex="-1" #addElement class="bofa--skiplink">
              </div>

              <div class="director-row">
                <mat-form-field class="max-zoom" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Company Name</mat-label>
                  <input matInput formControlName="companyName" required>
                  <mat-error>Please enter Company Name</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Start Date</mat-label>
                  <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" required>
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error>Please enter Start Date mm/dd/yyyy</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>End Date</mat-label>
                  <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" required>
                  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error>Please enter End Date mm/dd/yyyy</mat-error>
                </mat-form-field>
              </div>

              <div class="director-row">
                <mat-form-field class="max-zoom" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Vat Reg Number</mat-label>
                  <input matInput formControlName="vatRegNumber" required>
                  <mat-error>Please enter Vat Reg Number</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Last Accounts Filed Date</mat-label>
                  <input matInput [matDatepicker]="fixedDatePicker" formControlName="lastAccountFixedDate" required>
                  <mat-datepicker-toggle matSuffix [for]="fixedDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #fixedDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error>Please enter Last Accounts Filed Date mm/dd/yyyy</mat-error>
                </mat-form-field>

                <mat-form-field class="max-zoom field-space" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Status</mat-label>
                  <mat-select formControlName="status" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let status of directorshipData.directorshipStatus | keyvalue : valueAscOrder"
                      [value]="status.key">
                      {{status.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="directorForm.controls.status.hasError('required') ">Please select Status</mat-error>
                </mat-form-field>
              </div>

              <div class="director-row comments-row">
                <mat-form-field class="resize" hideRequiredMarker>
                  <mat-label for="commentsLabel"><abbr title="required">* </abbr>Comments</mat-label>
                  <textarea class="textarea-resize" matInput formControlName="comments" maxlength="4000"
                    cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5" id="commentsLabel"></textarea>
                  <mat-hint align="end">
                    {{directorForm.controls.comments.value.length}} / 4000
                  </mat-hint>
                  <mat-error *ngIf="directorForm.controls.comments.hasError('required')">Please enter
                    comments.</mat-error>
                </mat-form-field>
              </div>

              <div class="director-row remove-row">
                <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                  director</button>
              </div>
            </mat-card>
          </ng-container>
        </div>
      </div>

      <div *ngIf="afDirectorshipsList.length !== 0" class="double-bottom-space">
        <button [disabled]="afDirectorshipsList.invalid" type="button" class="bofa--button secondary button-center"
          (click)="createDirector('click')">Add director</button>
      </div>

      <div
        *ngIf="jobCountry === 'IND' && (directorshipForm.controls.director.value === '1' || directorshipForm.controls.compensated.value === '1')">
        <p><strong>Please download and complete the required OBA/OD Disclosure form and attach on the Certification
            Tab</strong></p>

        <div>
          <ul class="ul-style-type">
            <li><a href="/bsiAF/api/downloadOUSDirectorshipDocument?ousAttachmentID=58" 
              aria-label="outside business activities and outside directorship disclosure">
                Outside Business Activities & Outside Directorship Disclosure.pdf</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Directorships...
</ng-template>